import React, { FC } from 'react'
import { ButtonProps } from '@mui/material/Button'
import CustomButton from 'UI/Button/Button'
import type { ButtonProps as AntButtonProps } from 'antd'

interface CustomButtonProps extends Omit<ButtonProps, 'variant' | 'color' | 'size'> {
  styleType?: 'primary' | 'secondary' | 'icon' | 'secondary-icon'
  icon?: React.ReactNode
  size?: AntButtonProps['size']
}

const Button: FC<CustomButtonProps> = ({ 
  styleType = 'primary',
  icon,
  children,
  ...props 
}) => {
  return (
    <CustomButton
      buttonType={styleType}
      icon={icon}
      {...props}
    >
      {children}
    </CustomButton>
  )
}

export default Button
